module.exports = __webpack_public_path__ + "static/GKTrio-97c34960f66632a68c163d02940e43a4.jpg";